export function mapToEmoji(value) {
  if (!(value in mappings)) return "";
  return mappings[value];
}

// it might be that your IDE has difficulties showing emojis but they are there
const mappings = {
  woman: "💃",
  women: "💃",
  man: "🕺",
  men: "🕺",
  sustainable: "🌱",
  finland: "🇫🇮",
  onSale: "🤑",
  down: "🧥",
  knitwear: "🧶",
  jacket: "🧥",
  pants: "👖",
  shirt: "👔",
  short: "🩳",
  sportswear: "🚴",
  tshirt: "👕",
  underwear: "🩲",
  accessories: "👜",
  accessory: "👜",
  coat: "🧥",
  fur: "🧥",
  top: "👚",
  jeans: "👖",
  skirt: "👗",
  cardigan: "🧥",
  leather_jacket: "🧥",
  outdoor_jacket: "🧥",
  boots: "👢",
  belt: "👖",
  scarf: "🧣",
  bottom: "🩲",
  face_mask: "😷",
  trousers: "👖",
  shoes: "👠",
  bag: "👜",
  dress: "👗",
  leggings: "🦵",
  jewelry: "💎",
  sweater: "❄️",
  sweatshirt: "❄️",
  shoulder_bag: "🎒",
  clutch: "👝",
  backpack: "🎒",
  business_bag: "💼",
  coin_purse: "👛",
  "coin-purses": "👛",
  pouch: "👛",
  wallet: "👛",
  computer_tablet_bag: "💻",
  travel_bag: "🧳",
  earrings: "",
  necklaces: "💎",
  necklace: "💎",
  ring: "💍",
  bracelet: "💎",
  hat: "🎩",
  pique_shirt: "👕",
  sweatpants: "👖",
  purse: "👛",
  clothing: "👕",
  switzerland: "🇨🇭",

  hungry: "😋",
  raising_hands: "🙌",
  thinking_face: "🤔",
  hugging_face: "🤗",
  pointing_up: "☝️",
  pointing_down: "👇",
  waving_hand: "👋",
  flexing: "💪",
  pointing_left: "👈",
  thumbs_up: "👍",
  ok_hand: "👌",
  hammer_and_wrench: "🛠️",

  cart: "🛒",
  wishlist: "❤️",

  "recommendations.titles.hottest_deals": "👀",
  "recommendations.titles.clothes.bag": "👜",
  "recommendations.titles.clothes.overalls": "💃",
  "recommendations.titles.clothes.shoes": "👞",
  "recommendations.titles.clothes.trousers": "👖"
};
